module.exports = __webpack_public_path__ + "static/split-f5194e36047bec96a078f72edee963fc.png";